import React, { useState, useRef } from 'react';
import { Card, Button, Form, Alert } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext'
import CenteredContainer from './CenteredContainer';

const UpdateProfile = () => {
    const emailRef = useRef();
    const passwordRef = useRef();
    const passwordConfirmRef = useRef();
    const {updateEmail, updatePassword, currentUser} = useAuth();
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    
    const handleSubmit = (e) => {
        e.preventDefault();
        if(passwordRef.current.value === passwordConfirmRef.current.value){
            const promises = [];
            if(emailRef.current.value !== currentUser.email) promises.push(updateEmail(emailRef.current.value));
            if(passwordRef.current.value) promises.push(updatePassword(passwordRef.current.value));
            setError('');
            setLoading(true);
            Promise.all(promises).then(() => {
                history.push('/user');
            }).catch((error) => {
                setError('Failed to create an account.');
                console.log(error);
            }).finally(() => {
                setLoading(false);
            })
        }
        else setError('Passwords do no match.');
    }

    return (
    <CenteredContainer>
        <Card>
            <Card.Body>
                <h2 className='text-center mb-4'>Update Profile</h2>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group id='email'>
                        <Form.Label>Email</Form.Label>
                        <Form.Control type='email' ref={emailRef} defaultValue={currentUser.email} required></Form.Control>
                    </Form.Group>
                    <Form.Group id='password'>
                        <Form.Label>Password</Form.Label>
                        <Form.Control type='password' ref={passwordRef} placeholder='Leave blank to keep the same'></Form.Control>
                    </Form.Group>
                    <Form.Group id='password-confirm'>
                        <Form.Label>Password Confirmation</Form.Label>
                        <Form.Control type='password' ref={passwordConfirmRef} placeholder='Leave blank to keep the same'></Form.Control>
                    </Form.Group>
                    <Button disabled={loading} className='w-100' type='submit'>Update</Button>
                </Form>
            </Card.Body>
        </Card>
        <div className='w-100 text-center mt-2'>
            Don't want to change anything? <Link to='/user'>Cancel</Link>
        </div>
    </CenteredContainer>
    )
}

export default UpdateProfile;